import styled from 'styled-components'

import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import { Secondary } from 'components/Typography'

export const SomethingWentWrongContainer = styled(WhiteBlock)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.xxl};
`
export const SomethingWentWrongLabel = styled(Secondary)`
  color: ${theme.colors.moreGrey};
`
